/* Matrikar home (mkh) — shared behaviors, scoped to .mkh. No vehicle selector (native), no header menu. */
(function(){
  if(window.__mkhInit)return; window.__mkhInit=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function init(){
    var starSVG='<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.1 6.7.9-4.9 4.6 1.2 6.6L12 17.8 6.1 20.8l1.2-6.6L2.4 9l6.7-.9z"/></svg>';
    $$('.mkh .stars').forEach(function(s){ if(!s.__f){s.__f=1;s.innerHTML=starSVG.repeat(5);} });

    var stage=$('.mkh .hero-stage'); if(stage){ requestAnimationFrame(function(){stage.classList.add('reveal-hero');}); }

    /* hero parallax + spotlight */
    var heroBg=$('.mkh .hero-bg img'),heroSpot=$('.mkh .hero-spot');
    if(!reduce&&stage){
      var mx=0,my=0,ticking=false;
      function render(){ticking=false; if(heroBg)heroBg.style.transform='scale(1.08) translate('+(mx*-10)+'px,'+(my*-10)+'px)';}
      window.addEventListener('mousemove',function(e){
        mx=(e.clientX/window.innerWidth-0.5); my=(e.clientY/window.innerHeight-0.5);
        if(heroSpot){var r=stage.getBoundingClientRect();heroSpot.style.setProperty('--sx',(e.clientX-r.left)+'px');heroSpot.style.setProperty('--sy',(e.clientY-r.top)+'px');}
        if(!ticking){ticking=true;requestAnimationFrame(render);}
      },{passive:true});
    }

    /* marquee: duplicate row for seamless loop */
    /* marquee row is rendered 2x in Liquid; no JS duplication needed */

    /* reveal on scroll (+ stagger) */
    var items=$$('.mkh .reveal, .mkh [data-stagger]');
    if(reduce||!('IntersectionObserver'in window)){ items.forEach(function(r){r.classList.add('in');}); }
    else{
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ var el=e.target;
        if(el.hasAttribute('data-stagger')){Array.prototype.forEach.call(el.children,function(c,i){c.style.transitionDelay=(i*60)+'ms';});}
        el.classList.add('in'); io.unobserve(el);} });},{threshold:0.14,rootMargin:'0px 0px -6% 0px'});
      items.forEach(function(r){io.observe(r);});
    }

    /* count-up */
    function countUp(el){var t=parseFloat(el.getAttribute('data-count')),d=parseInt(el.getAttribute('data-dec')||'0',10);
      if(reduce){el.textContent=(d?t.toFixed(d):t.toLocaleString('en-US'));return;}
      var s=null,dur=1400;function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/dur,1),e=1-Math.pow(1-p,3),v=t*e;
        el.textContent=d?v.toFixed(d):Math.round(v).toLocaleString('en-US');if(p<1)requestAnimationFrame(step);}requestAnimationFrame(step);}
    var counters=$$('.mkh [data-count]');
    if('IntersectionObserver'in window){var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){countUp(e.target);cio.unobserve(e.target);}});},{threshold:0.6});counters.forEach(function(c){cio.observe(c);});}
    else{counters.forEach(countUp);}

    /* faq accordion */
    $$('.mkh .faq-q').forEach(function(q){q.addEventListener('click',function(){var it=q.parentElement,a=it.querySelector('.faq-a'),open=it.classList.toggle('open');if(a)a.style.maxHeight=open?(a.scrollHeight+'px'):'0px';});});

    /* Diamond swatch image swap */
    var dImg=$('.mkh #diamondImg'),swName=$('.mkh #swatchName');
    $$('.mkh .swatch').forEach(function(sw){sw.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();
      $$('.mkh .swatch').forEach(function(s){s.setAttribute('aria-pressed','false');});sw.setAttribute('aria-pressed','true');
      if(swName)swName.textContent=sw.getAttribute('data-name');var _fl=document.querySelector('.mkh #mkfeat-link'),_ln=sw.getAttribute('data-link');if(_fl&&_ln)_fl.setAttribute('href',_ln);
      var src=sw.getAttribute('data-img');if(!dImg||!src||dImg.getAttribute('src')===src)return;
      new Image().src=src;
      dImg.style.transition='transform .34s cubic-bezier(.4,0,.2,1),opacity .3s ease';dImg.style.opacity='0';dImg.style.transform='translateX(-9%)';
      window.setTimeout(function(){dImg.src=src;dImg.style.transition='none';dImg.style.transform='translateX(9%)';dImg.style.opacity='0';void dImg.offsetWidth;
        dImg.style.transition='transform .42s cubic-bezier(.2,.7,.2,1),opacity .36s ease';dImg.style.opacity='1';dImg.style.transform='translateX(0)';},300);});});

    /* magnetic buttons */
    if(!reduce){$$('.mkh .magnetic').forEach(function(b){
      b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();b.style.transform='translate('+((e.clientX-r.left-r.width/2)*0.25)+'px,'+((e.clientY-r.top-r.height/2)*0.35)+'px)';});
      b.addEventListener('mouseleave',function(){b.style.transform='';});});}

    /* mobile sticky CTA: show after hero scrolls past */
    var sticky=$('.mkh .sticky-cta'),ref=$('.mkh .hero-stage')||$('.mkh');
    if(sticky&&ref&&'IntersectionObserver'in window){
      new IntersectionObserver(function(en){sticky.classList.toggle('show',!en[0].isIntersecting);},{threshold:0}).observe(ref);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
})();
